exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ql-snow {\n  text-align: left;\n}\n#ql-editor1 {\n  margin-top: -15px;\n}\n#ql-editor {\n  margin-top: -15px;\n}\n/* 富文本高度 */\n.ql-editor {\n  height: 320px;\n}\n.ql-editor1 {\n  height: 320px;\n}\n.el-table th {\n  text-align: center;\n}\n.el-table td {\n  text-align: center;\n}\n.page {\n  text-align: center;\n  margin-top: 20px;\n}\n", ""]);

// exports
